import React, { Component } from 'react'
import FlatButton from 'material-ui/FlatButton'
import { localDebug } from '../../lib/lib'
import config from '../../config/config'
import images from '../../config/images'
import randToken from 'rand-token'

class SeminarMode extends Component {
  constructor (props) {
    super(props)
    this.state = {
      iOS: true
    }
  }

  handleClick = async () => {
    if (this.state.iOS) {
      window.location = `fvwebinar://open.fvwebinar${window.location.pathname + window.location.search}`
    } else {
      window.location = `fvwebinar://open.fvwebinar/${(window.location.pathname + window.location.search).substr(1)}`
    }
  }

  handleDownload = async () => {
    if (this.state.iOS) {
      window.location = 'https://itunes.apple.com/jp/app/freshvoice-webinar/id1325343868'
    } else {
      window.location = 'https://play.google.com/store/apps/details?id=com.fvwebinar'
    }
  }

  componentDidMount () {
    if (window.location.pathname === '/' && (localDebug() || window.location.hostname === 'localhost')) {
      window.location = '/' + randToken.generate(2)
    }
    const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
    this.setState({iOS})
    if (window.location.pathname === '/') {
      if (config.API_HOST === 'workshop.tokyo') {
        window.location.href = '/webinar/?token=' + config.WEBINAR_PROD_TEST2_DEBUG_TOKEN
      } else {
        window.location.href = '/webinar/?token=' + config.WEBINAR_DEV_TEST2_DEBUG_TOKEN
      }
    }
  }

  render () {
    return (
      <div css={{overflow: 'hidden'}}>
        <img src={images.webinar_logo} alt="logo" style={{
          width: '50vw',
          display: 'block',
          marginLeft: 'auto',
          marginRight: 'auto',
          alignItems: 'center',
          marginTop: '15vw',
          backgroundColor: '#0084ff'
        }}/>
        <FlatButton onClick={this.handleClick} style={styles.button}>
          アプリで開く
        </FlatButton>
        <FlatButton onClick={this.handleDownload} style={styles.button}>
          アプリをダウンロードする
        </FlatButton>
      </div>
    )
  }

}

const styles = {
  button: {
    width: '50vw',
    height: '10vw',
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
    alignItems: 'center',
    marginTop: '15vw',
    backgroundColor: '#eee'
  },
  text: {
    width: '50vw',
    height: '10vw',
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
    alignItems: 'center',
    marginTop: '1vw'
  }

}

export default SeminarMode



// WEBPACK FOOTER //
// ./src/routes/PrepareSession/mobile.js